import React, { useState, useRef } from 'react';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
import { CalendarOutlined } from '@ant-design/icons';
import styled from 'styled-components';

const { RangePicker } = DatePicker;

const PickerWrapper = styled.div`
  width: 100%;
  position: relative;
  display: inline-block;

  .ant-picker {
    width: 100%;
  }

  .ant-picker-input > input {
    text-align: center;
  }

  .ant-picker-range-separator {
    padding: 0 4px;
  }
`;

const StyledRangePicker = styled(RangePicker)`
  width: 100%;
  border-radius: 10px;
  border: 1px solid #e9e9e9;
  padding: 8px 12px;
  cursor: pointer;

  &:hover,
  &:focus {
    border-color: #ed7836;
  }

  .ant-picker-range-separator {
    padding: 0 8px;
  }
  .ant-picker-input > input {
    text-align: left;
  }
`;

const ChooseMonthDate = ({ value, onChange }) => {
  const [open, setOpen] = useState(false);
  const pickerRef = useRef(null);

  const handleOpenChange = (open) => {
    setOpen(open);
  };

  const handleChange = (dates) => {
    if (onChange) {
      onChange(dates);
    }
    if (dates?.[0] && dates?.[1]) {
      setOpen(false);
    }
  };

  return (
    <PickerWrapper
      ref={pickerRef}
      className="h-10 xl:h-8 xl:rounded-[4px] 2xl:h-9 2xl:rounded-[4px]"
    >
      <StyledRangePicker
        open={open}
        onOpenChange={handleOpenChange}
        placeholder={['yyyy/mm', 'yyyy/mm']}
        value={
          value
            ? [dayjs(value[0]), value[1] ? dayjs(value[1]) : null]
            : [null, null]
        }
        onChange={handleChange}
        picker="month"
        format="YYYY/MM"
        suffixIcon={<CalendarOutlined style={{ color: '#8C8C8C' }} />}
        showTime={false}
        allowClear={true}
        inputReadOnly={true}
        style={{ width: '100%' }}
        className="h-10 xl:h-8 xl:!rounded-[4px] 2xl:h-9 2xl:!rounded-[4px]"
        classNames={{
          popup: {
            root: 'month-picker-dropdown xl:!rounded-[4px] 2xl:h-9 2xl:!rounded-[4px]',
          },
        }}
      />
    </PickerWrapper>
  );
};

export default ChooseMonthDate;
